export type ApiResult<A> = "loading" | "error" | A;

export const isLoaded = <A>(result: ApiResult<A>): result is A => result != 'loading' && result != 'error'
